<div *ngIf="tools.includes(ImageActionType.BackgroundRemoval)" class="group mt-3 mb-3">
	<button mat-flat-button color="primary" class="block with-loading" (click)="removeBackground()" [disabled]="loadingAction === ImageActionType.BackgroundRemoval">
		<span class="text" i18n="Remove Background Button@@imageToolBackgroundRemoveBackgroundButtonLabel"><mat-icon inline>auto_awesome</mat-icon> Remove Background</span>
		<span class="spinner"><mat-spinner diameter="20" color="accent"></mat-spinner></span>
	</button>
</div>

<div *ngIf="tools.includes(ImageActionType.BlurBackground)" class="group mt-3 mb-3">
	<button mat-flat-button color="primary" class="block with-loading" (click)="blurBackground()" [disabled]="loadingAction === ImageActionType.BlurBackground">
		<span class="text" i18n="Blur Background Button@@imageToolBackgroundBlurBackgroundButtonLabel"><mat-icon inline>auto_awesome</mat-icon> Blur Background</span>
		<span class="spinner"><mat-spinner diameter="20" color="accent"></mat-spinner></span>
	</button>
</div>

<div *ngIf="tools.includes(ImageActionType.EnhanceImage)" class="group mt-3 mb-3">
	<button mat-flat-button color="primary" class="block with-loading" (click)="enhanceImage()" [disabled]="loadingAction === ImageActionType.EnhanceImage">
		<span class="text" i18n="Enhance Image Button@@imageToolBackgroundEnhanceImageButtonLabel"><mat-icon inline>auto_awesome</mat-icon> Enhance Image</span>
		<span class="spinner"><mat-spinner diameter="20" color="accent"></mat-spinner></span>
	</button>
</div>

<div *ngIf="tools.includes(ImageActionType.ReplaceBackground)" class="group mt-3 mb-3">
	<app-textarea-input
		label="Replace Background Prompt"
		i18n-label="Replace Background Prompt@@imageToolBackgroundReplaceBackgroundPromptLabel"
		placeholder="Enter a prompt of what you want to replace the background with."
		i18n-placeholder="Replace Background Prompt Placeholder@@imageToolBackgroundReplaceBackgroundPromptPlaceholder"
		[parentForm]="replaceBackgroundForm"
		[controlName]="'bg_prompt'"
	></app-textarea-input>

	<button mat-flat-button color="primary" class="block with-loading mt-3" (click)="replaceBackground()" [disabled]="loadingAction === ImageActionType.ReplaceBackground">
		<span class="text"
			  i18n="Generate Button@@imageToolBackgroundGenerateButtonLabel"><mat-icon inline>auto_awesome</mat-icon> Generate</span>
		<span class="spinner"><mat-spinner diameter="20" color="accent"></mat-spinner></span>
	</button>
</div>
